/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategoriesRoutingModule
 * Purpose		: Routing module for Categories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CategoriesListComponent } from './CategoriesList.component';
import { CategoriesAddComponent }  from './CategoriesAdd.component';
import { CategoriesEditComponent } from './CategoriesEdit.component';
import { CategoriesDetailsComponent } from './CategoriesDetails.component';

const CategoriesRoutes: Routes = [
	{ path: 'Categories',  component: CategoriesListComponent },
	{ path: 'Categories/add', component: CategoriesAddComponent },
	{ path: 'Categories/:id', component: CategoriesEditComponent },
	{ path: 'Categories/Details/:id', component: CategoriesDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(CategoriesRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class CategoriesRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Categories/Categories-routing.module.ts